"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var core_1 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab/");
var __1 = require("../..");
var constants_1 = require("../../../../../../shared/constants");
var TAG_STRING_FIELD = 'tagStrings';
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        content: {
            paddingTop: 2,
            paddingBottom: 48,
        },
        dateText: {
            fontWeight: 400,
            color: '#767676',
        },
        oppContent: {
            maxWidth: 0,
            paddingLeft: 0,
            paddingRight: 0,
        },
        regularText: {
            fontWeight: 400,
        },
        timelineDot: {
            backgroundColor: theme.palette.primary.light,
        },
        timelineConnector: {
            backgroundColor: theme.palette.primary.light,
        },
        chip: {
            backgroundColor: theme.palette.primary.light,
            color: '#FFFFFF',
            borderRadius: 5,
            marginRight: 2,
        },
    });
});
var linkChangeKeyDictionary = {
    description: 'Description',
    isFile: 'File',
    state: 'Link Status',
    userEmail: 'Link Owner',
    longUrl: 'Original Link',
    tagStrings: 'Link Tags',
};
var convertToDateString = function (oldDateString) {
    var desiredDateFormat = 'MMMM D, YYYY h:mm A';
    return (0, moment_timezone_1.default)(oldDateString).tz('Singapore').format(desiredDateFormat);
};
function TagList(_a) {
    var tagStrings = _a.tagStrings;
    var classes = useStyles();
    var tags = tagStrings.split(constants_1.TAG_SEPARATOR);
    return (react_1.default.createElement(react_1.default.Fragment, null, tagStrings === ''
        ? 'no tag'
        : tags.map(function (tag) { return react_1.default.createElement(core_1.Chip, { label: tag, className: classes.chip }); })));
}
function LinkHistoryItem(_a) {
    var changeSet = _a.changeSet, removeBottomConnector = _a.removeBottomConnector;
    var classes = useStyles();
    var shortUrl = (0, __1.useDrawerState)().relevantShortLink || '';
    var fullURL = "".concat(document.location.protocol, "//").concat(document.location.host, "/").concat(shortUrl);
    var createStatusText = function (currValue) {
        return (react_1.default.createElement(core_1.Typography, { variant: "h6" },
            fullURL,
            react_1.default.createElement("span", { className: classes.regularText }, " created for "),
            currValue));
    };
    var updateStatusText = function (currKey, prevValue, currValue) {
        return (react_1.default.createElement(core_1.Typography, { variant: "h6" },
            linkChangeKeyDictionary[currKey],
            react_1.default.createElement("span", { className: classes.regularText }, " was updated from "),
            currKey === TAG_STRING_FIELD ? (react_1.default.createElement(TagList, { tagStrings: prevValue.toString() })) : (prevValue),
            react_1.default.createElement("span", { className: classes.regularText }, " to "),
            currKey === TAG_STRING_FIELD ? (react_1.default.createElement(TagList, { tagStrings: currValue.toString() })) : (currValue)));
    };
    return (react_1.default.createElement(lab_1.TimelineItem, null,
        react_1.default.createElement(lab_1.TimelineOppositeContent, { className: classes.oppContent }),
        react_1.default.createElement(lab_1.TimelineSeparator, null,
            react_1.default.createElement(lab_1.TimelineDot, { className: classes.timelineDot }),
            !removeBottomConnector && (react_1.default.createElement(lab_1.TimelineConnector, { className: classes.timelineConnector }))),
        react_1.default.createElement(lab_1.TimelineContent, { className: classes.content },
            react_1.default.createElement(core_1.Typography, { className: classes.dateText, variant: "body2" }, convertToDateString(changeSet.updatedAt)),
            changeSet.type === 'create'
                ? createStatusText(changeSet.currValue)
                : updateStatusText(changeSet.key, changeSet.prevValue, changeSet.currValue))));
}
exports.default = LinkHistoryItem;
